<template>
	<div class="my-3 my-md-5">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="card">
						<div class="card-header justify-content-between">
							<h3 class="card-title">WordPress Details</h3>
							<button type="button" class="btn btn-sm btn-outline-primary text-uppercase" data-toggle="modal" data-target="#detailsModal" @click="openAddModal"><i class="fe fe-plus d-block" title="Add New"></i></button>
						</div>
						<div class="table-responsive">
							<table class="table table-hover table-outline table-vcenter text-nowrap card-table">
								<thead>
									<tr>
										<th class="text-center">Sr. No.</th>
										<th>Property</th>
										<th>Host</th>
										<th>Username</th>
										<th>Password</th>
										<th class="text-center">Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr v-if="dataArray.length == 0">
										<td colspan="8" class="text-center">No data available</td>
									</tr>
									<tr v-else v-for="(data, index) in dataArray" :key="data._id">
										<td>
											<div class="text-center">
												{{ index+1 }}
											</div>
										</td>
										<td>
											<div>
												{{ data.property }}
											</div>
										</td>
										<td>
											<div>
												{{ data.host }}
											</div>
										</td>
										<td>
											<div>
												{{ data.username }}
											</div>
										</td>
										<td>
											<div>
												<a href="javascript:void(0);" class="show-password" @click="showPassword(data.password)"><small>&#8902;&#8902;&#8902;&#8902;</small></a>
											</div>
										</td>
										<td class="text-center">
											<button type="button" class="btn btn-sm btn-default" title="Edit" @click="openEditModal(data)"><i class="fe fe-edit"></i></button>
											<button type="button" class="btn btn-sm btn-default ml-1" title="Delete" @click="openDeleteModal(data._id)"><i class="fe fe-trash"></i></button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Add / Edit Modal -->
		<div class="modal fade" id="detailsModal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<form id="dash-form" class="modal-content" @submit.prevent="submitDetailsForm">
					<div class="modal-header">
						<template v-if="modalTypeEdit">
							<h5 class="modal-title" id="exampleModalLabel">Edit Details</h5>
						</template>
						<template v-else>
							<h5 class="modal-title" id="exampleModalLabel">Add Details</h5>
						</template>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="row m-0">
							<div class="col-md-12">
								<div class="form-group alert alert-danger" role="alert">
									Woops! Something Went Wrong, Please Try Again.
								</div>  
							</div>
							<div class="col-md-6">
								<TextField :data="formData.property" name="property" label="Property" :required="true" v-bind:value.sync="formData.property"/>
								<TextField :data="formData.host" name="host" label="Host" :required="true" v-bind:value.sync="formData.host"/>
							</div>
							<div class="col-md-6">
								<TextField :data="formData.username" name="username" label="Username" :required="true" v-bind:value.sync="formData.username"/>
								<Password :data="formData.password" name="password" :required="true" v-bind:value.sync="formData.password"/>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="reset" class="btn btn-secondary" data-dismiss="modal">Close</button>
						<button type="submit" id="submit" class="btn btn-primary ml-2 text-uppercase">Sumbit</button>
					</div>
				</form>
			</div>
		</div>
		<!-- Delete Modal -->
		<div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">Confirm Delete</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						Delete this Data?
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
						<button type="button" class="btn btn-primary" @click="confirmDelete">Confirm</button>
					</div>
				</div>
			</div>
		</div>
		<!-- Password Modal -->
		<div ref="modal" class="modal fade" id="passwordModal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div id="dash-form" class="modal-content" @submit.prevent="submitPassPin">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">View Password</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="row m-0">
							<div class="col-md-12">
								<div v-if="!dataPass['validPin']" class="form-group alert alert-danger" role="alert" style="display: block;">
									Enter valid PIN to view password
								</div>  
							</div>
							<div class="col-md-12">
								<TextField :data="dataPass['pin']" name="passwordPin" label="PIN" v-bind:value.sync="dataPass['pin']"/>
							</div>
							<div class="col-md-12">
								<div v-if="dataPass['validPin']" class="form-group alert alert-success" role="alert" style="display: block;">
									<div class="row">
										<div class="col-10"><strong>Password:</strong> {{ decrypt(dataPass['value']) }}</div>
										<div class="col-2 d-flex justify-content-end align-items-center"><a href="javascript:void(0);" class="d-inline-block copy-password" data-toggle="tooltip" data-placement="bottom" title="Click to copy" @click="copyToClipboard(decrypt(dataPass['value']), $refs.modal)"><i class="fe fe-clipboard"></i></a></div>
									</div>
								</div>  
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// @ is an alias to /src
import TextField from '@/components/form/TextField.vue'
import Password from '@/components/form/Password.vue'

export default {
	name: 'WordPress',
	components: {
		TextField,
		Password
	},
	data() {
		return {
			modalTypeEdit: false,
			formData: {
				property: '',
				host: '',
				username: '',
				password: ''
			},
			dataId: '',
			dataPass: {
				validPin: false,
				pin: '',
				value: ''
			},
			dataArray: []
		}
	},
	computed: {
		passwordPin: function() {
			return this.$store.getters.getPasswordPin;
		},
	},
	mounted() {
		// Hide loader
		this.$store.dispatch('setLoading', false);
		/* global $ */
		let self = this;
		// Reset Form On Modal Hide
		$('#detailsModal').on('hidden.bs.modal', function () {
			self.resetFormData();
		});
		// Reset Delete Id On Modal Hide
		$('#deleteModal').on('hidden.bs.modal', function () {
			self.deleteId = '';
		});
		// Reset Password On Modal Hide
		$('#passwordModal').on('hidden.bs.modal', function () {
			self.dataPass['validPin'] = false;
			self.dataPass['pin'] = '';
			self.dataPass['value'] = '';
		});
	    // Dummy Data
	    /*this.dataArray = [
		{
			id: '001',
			property: '.store',
			host: 'get.store',
			username: 'admin',
			password: 'password'
		},
		{
			id: '002',
			property: '.tech',
			host: 'get.tech',
			username: 'admin',
			password: 'password'
		},
		{
			id: '003',
			property: '.space',
			host: 'get.space',
			username: 'admin',
			password: 'password'
		},
		{
			id: '004',
			property: '.online',
			host: 'get.online',
			username: 'admin',
			password: 'password'
		},
		{
			id: '005',
			property: '.site',
			host: 'get.site',
			username: 'admin',
			password: 'password'
		}
		]*/;
	    // Get WordPress Listing
	    this.getData('wordpress-details', self.dataArray);
	},
	beforeDestroy() {
		/* global $ */
		let self = this;
		// Unsubscribe WordPress listing data
	    this.getData('wordpress-details', self.dataArray, 'unsubscribe');
	},
	methods: {
		submitDetailsForm: function() {
			let self = this;
			// Check Vee Validate
			self.$validator.validateAll().then((result) => {
				if (result) {
					// Encrypt Password
					this.formData.password = this.encrypt(this.formData.password);
					// Add / Edit WordPress Data
					if(self.modalTypeEdit == true) {
						self.sendData('wordpress-details', self.formData, self.dataId);
					}
					else {
						self.sendData('wordpress-details', self.formData);
					}
					return;
				}
			});
		},
		confirmDelete: function() {
			// Delete WordPress Data
			this.deleteData('wordpress-details', this.dataId);
		},
		resetFormData: function() {
			this.modalTypeEdit = false;
			this.dataId = '';
			// Prefill Edit Values
			this.formData.property = '';
			this.formData.host = '';
			this.formData.username = '';
			this.formData.password = '';
			// Emit Reset Event
			this.$root.$emit('reset-validation');
		},
		openAddModal: function() {
			this.modalTypeEdit = false;
			// Show Modals
			$('#detailsModal').modal('show');
		},
		openEditModal: function(obj) {
			this.modalTypeEdit = true;
			// Prefill Edit Values
			this.dataId = obj._id;
			this.formData.property = obj.property;
			this.formData.host = obj.host;
			this.formData.username = obj.username;
			this.formData.password = this.decrypt(obj.password);
			// Show Modal
			$('#detailsModal').modal('show');
		},
		openDeleteModal: function(id) {
			this.dataId = id;
			// Show Modal
			$('#deleteModal').modal('show');
		},
		showPassword: function(password) {
			this.dataPass['value'] = password;
			// Show Modal
			$('#passwordModal').modal('show');
		}
	},
	watch: {
		'dataPass.pin': function (val) {
			if(val == this.passwordPin) {
				this.dataPass['validPin'] = true;
			}
			else {
				this.dataPass['validPin'] = false;
			}
		}
	}
}
</script>
